module.exports = __webpack_public_path__ + "img/wx-share-3.20dad30b.jpg";